import React from 'react';
import './index.less';
import { InfoCircleFilled } from '@ant-design/icons';
import classNames from 'classnames';

const WorningInfo = ({ info, type = 'default' }) => {
  const infoClass = classNames({
    'warning-info': type === 'warning',
    'default-info': type === 'default',
    'error-info': type === 'error',
  });

  return (
    <div className={infoClass}>
      <InfoCircleFilled />
      {info}
    </div>
  );
};

export default WorningInfo;
